export const getMintErrorReason = (e: Error) => {
  const reason = e.message.split('\n')[0].trim();

  // Finish sentence with a '.'
  const normalisedReason = reason[reason.length - 1] === '.' ? reason : `${reason}.`;

  return normalisedReason;
};
